import { decorate, observable, action, runInAction } from 'mobx';
import WebApi, { getErrorMessage, getValidationErrors } from 'modules/WebApi';
//import { StoreInterface, RootStoreInterface } from 'interfaces';
import CommonStore from "modules/CommonStore";
import CoordinatorsAPI from "./api"

class coordinatorsStore extends CommonStore {

  constructor(rootStore: RootStoreInterface) {
    const apiClient = new CoordinatorsAPI(rootStore.apiClient);

    super(
        rootStore,
        apiClient,
        rootStore.specifications["Coordinators"]
    );
  }



}


decorate(coordinatorsStore, {

});



export default coordinatorsStore;
